import React from 'react';
import { PageHeader } from 'antd';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const routes = [
  {
    path: '/',
    breadcrumbName: 'Base',
  },
  {
    path: 'Colors',
    breadcrumbName: 'Colors',
  },
];

const Colors = () => {
  return (
    <>
      <PageHeader title="Colors" breadcrumb={{ routes }} style={{ padding: 10 }} />

      <div className="MF_area">
        <h6>Basic</h6>
        <ul className="colors">
          <li><span className="bg_black"></span>black</li>
          <li><span className="bg_white border_black"></span>white</li>
        </ul>
        <h6>Gray</h6>
        <ul className="colors">
          <li><span className="bg_gray1"></span>gray1</li>
          <li><span className="bg_gray2"></span>gray2</li>
          <li><span className="bg_gray3"></span>gray3</li>
          <li><span className="bg_gray4"></span>gray4</li>
          <li><span className="bg_gray5"></span>gray5</li>
          <li><span className="bg_gray6"></span>gray6</li>
          <li><span className="bg_gray7"></span>gray7</li>
          <li><span className="bg_gray8"></span>gray8</li>
        </ul>
        <h6>BlueGray</h6>
        <ul className="colors">
          <li><span className="bg_bluegray1"></span>bluegray1</li>
          <li><span className="bg_bluegray2"></span>bluegray2</li>
          <li><span className="bg_bluegray3"></span>bluegray3</li>
          <li><span className="bg_bluegray4"></span>bluegray4</li>
          <li><span className="bg_bluegray5"></span>bluegray5</li>
          <li><span className="bg_bluegray6"></span>bluegray6</li>
        </ul>
        <h6>Blue</h6>
        <ul className="colors">
          <li><span className="bg_blue1"></span>blue1</li>
          <li><span className="bg_blue2"></span>blue2</li>
          <li><span className="bg_blue3"></span>blue3</li>
          <li><span className="bg_blue4"></span>blue4</li>
          <li><span className="bg_blue5"></span>blue5</li>
          <li><span className="bg_blue6"></span>blue6</li>
        </ul>
        <h6>Green</h6>
        <ul className="colors">
          <li><span className="bg_green1"></span>green1</li>
          <li><span className="bg_green2"></span>green2</li>
          <li><span className="bg_green3"></span>green3</li>
          <li><span className="bg_green4"></span>green4</li>
          <li><span className="bg_green5"></span>green5</li>
          <li><span className="bg_green6"></span>green6</li>
        </ul>
        <h6>Red</h6>
        <ul className="colors">
          <li><span className="bg_red1"></span>red1</li>
          <li><span className="bg_red2"></span>red2</li>
          <li><span className="bg_red3"></span>red3</li>
          <li><span className="bg_red4"></span>red4</li>
          <li><span className="bg_red5"></span>red5</li>
          <li><span className="bg_red6"></span>red6</li>
        </ul>
        <h6>Purple</h6>
        <ul className="colors">
          <li><span className="bg_purple1"></span>purple1</li>
          <li><span className="bg_purple2"></span>purple2</li>
          <li><span className="bg_purple3"></span>purple3</li>
          <li><span className="bg_purple4"></span>purple4</li>
          <li><span className="bg_purple5"></span>purple5</li>
          <li><span className="bg_purple6"></span>purple6</li>
        </ul>
        <h6>Brown</h6>
        <ul className="colors">
          <li><span className="bg_brown1"></span>brown1</li>
          <li><span className="bg_brown2"></span>brown2</li>
        </ul>
      </div>
    </>
  );
}

export default Colors;
